var map = {
	"./03E58071-155A-47E0-815E-DA6798C2D53F_1_105_c.jpeg": "./src/images/research/community/03E58071-155A-47E0-815E-DA6798C2D53F_1_105_c.jpeg",
	"./1C70BF80-EFB3-4032-A301-AD79D331B1ED_1_105_c.jpeg": "./src/images/research/community/1C70BF80-EFB3-4032-A301-AD79D331B1ED_1_105_c.jpeg",
	"./4852ABEC-6151-4509-B8E4-A894AB55BE0A_1_102_o.jpeg": "./src/images/research/community/4852ABEC-6151-4509-B8E4-A894AB55BE0A_1_102_o.jpeg",
	"./4C8AD983-32CA-472B-94AE-883E6CFD9AFE_4_5005_c.jpeg": "./src/images/research/community/4C8AD983-32CA-472B-94AE-883E6CFD9AFE_4_5005_c.jpeg",
	"./6F29BE9E-8A0D-4145-B5A5-CA4DCF39666B_1_102_o.jpeg": "./src/images/research/community/6F29BE9E-8A0D-4145-B5A5-CA4DCF39666B_1_102_o.jpeg",
	"./7B95A6A9-B35D-4135-B366-66C36C346E24_1_102_o.jpeg": "./src/images/research/community/7B95A6A9-B35D-4135-B366-66C36C346E24_1_102_o.jpeg",
	"./8EAA2280-60D0-4515-A572-59A8E98825B6_1_105_c.jpeg": "./src/images/research/community/8EAA2280-60D0-4515-A572-59A8E98825B6_1_105_c.jpeg",
	"./99B15633-D383-4179-ABC4-54D800DC06BF_1_105_c.jpeg": "./src/images/research/community/99B15633-D383-4179-ABC4-54D800DC06BF_1_105_c.jpeg",
	"./A053AE46-EEEA-4FC0-B9E8-17A7CA65A616_1_105_c.jpeg": "./src/images/research/community/A053AE46-EEEA-4FC0-B9E8-17A7CA65A616_1_105_c.jpeg",
	"./A15B845A-B45D-4A88-931B-F6C18FFF34CC_1_105_c.jpeg": "./src/images/research/community/A15B845A-B45D-4A88-931B-F6C18FFF34CC_1_105_c.jpeg",
	"./AF24CA4E-3E30-46B5-A355-BECBA2A48373_1_105_c.jpeg": "./src/images/research/community/AF24CA4E-3E30-46B5-A355-BECBA2A48373_1_105_c.jpeg",
	"./B7D9C865-D61F-4806-B175-EAD7761C03A9_1_105_c.jpeg": "./src/images/research/community/B7D9C865-D61F-4806-B175-EAD7761C03A9_1_105_c.jpeg",
	"./CE5649EA-E2C5-4DDB-8F44-93B14A36B353_1_105_c.jpeg": "./src/images/research/community/CE5649EA-E2C5-4DDB-8F44-93B14A36B353_1_105_c.jpeg",
	"./D127FEA3-8964-44B8-AA0F-65205DA40C6D_1_105_c.jpeg": "./src/images/research/community/D127FEA3-8964-44B8-AA0F-65205DA40C6D_1_105_c.jpeg",
	"./D66E0D47-7CA0-46D9-8CC9-B83308EF7464_1_105_c.jpeg": "./src/images/research/community/D66E0D47-7CA0-46D9-8CC9-B83308EF7464_1_105_c.jpeg",
	"./DF2BF201-DCDF-44D5-BE83-17FCACE528E1_1_105_c.jpeg": "./src/images/research/community/DF2BF201-DCDF-44D5-BE83-17FCACE528E1_1_105_c.jpeg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/research/community sync \\.(png|jpe?g|svg)$";